import {GetHospitalizationUrl} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetHospitalizationUrl} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetHospitalizationUrl = (): GetHospitalizationUrl =>
	new RemoteGetHospitalizationUrl(
		makeBFFApiUrl(ExternalLinkPoint.hospitalization),
		makeAuthorizeHttpClientDecorator(),
	);
